import { render, staticRenderFns } from "./LimitProductCreate.vue?vue&type=template&id=c5eb2e8c&"
import script from "./LimitProductCreate.vue?vue&type=script&lang=js&"
export * from "./LimitProductCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports